<template>
  <v-dialog v-model="dialog" persistent width="600">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>{{ form.id ? "edit" : "add" }}</v-icon>
          {{ form.id ? "Editar CAS" : "Crear CAS" }}
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-layout wrap>
                <v-flex xs6>
                  <v-text-field
                    type="date"
                    name="label"
                    label="Fecha presentación en ASP-B"
                    v-model="form.fecha_presentacion"
                    autofocus
                    maxlength="50"
                    :rules="$validate(['required'])"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    type="date"
                    name="label"
                    label="Fecha trámite CAS"
                    v-model="form.fecha_tramite"
                    autofocus
                    maxlength="50"
                    :rules="$validate(['required'])"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-layout>
            <v-layout wrap>
              <v-flex xs6>
                <v-text-field
                  type="Number"
                  min="0"
                  name="label"
                  label="Años calificados a la fecha"
                  v-model="form.anios"
                  autofocus
                  maxlength="50"
                    :rules="[
                    (v) => {
                      if (v == null) return 'El campo es obligatorio.';
                      if(v<0)
                        return 'El campo no puede ser negativo.'
                      if(v >= 100)
                        return 'No puede ingresar un número tan grande.';
                      return true;
                    },
                  ]"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs6>
                <v-text-field
                  type="Number"
                  min="0"
                  name="label"
                  label="Meses calificados a la fecha"
                  v-model="form.meses"
                  autofocus
                  maxlength="50"
                    :rules="[
                    (v) => {
                      if (v == null) return 'El campo es obligatorio.';
                      if(v<0)
                        return 'El campo no puede ser negativo.'
                      if(v >= 100)
                        return 'No puede ingresar un número tan grande.';
                      return true;
                    },
                  ]"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs6>
                <v-text-field
                  type="Number"
                  min="0"
                  name="label"
                  label="Dias calificados a la fecha"
                  v-model="form.dias"
                  autofocus
                  maxlength="50"
                    :rules="[
                    (v) => {
                      if (v == null) return 'El campo es obligatorio.';
                      if(v<0)
                        return 'El campo no puede ser negativo.'
                      if(v >= 100)
                        return 'No puede ingresar un número tan grande.';
                      return true;
                    },
                  ]"
                ></v-text-field>
              </v-flex>
              <v-flex md12>
                  
                
                <input
                  id="input"
                  type="file"
                  @change="handleFileUpload()"
                  ref="file"
                  accept="image/*, application/pdf"
                  :rules="$validate(['required'])"
                  required
                />
                <p class="red--text body-1" v-if="error">
                  {{ mensjageerror }}
                </p>
              </v-flex>
            </v-layout>



          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
      file:"",
      error: false,
      cargado: false,
      mensjageerror: ""
    };
  },
  mounted() {
    this.$bus.$on("openDialogCrearActualizarCas", (item) => {
      this.form = item;
      this.dialog = true;
    });
  },
  methods: {
    close() {
      (this.form = {}), (this.loading = false);
      this.file = null;
      this.cargado= false;
      this.valid = false;
      this.$bus.$emit("closeDialog");
      this.dialog = false;
    },
       handleFileUpload() {
      if (this.$refs.file.value !== "") {
        this.cargado = true;
        const file = this.$refs.file.files[0];
        if (this.$refs.file.files[0].size > 2048999) {
          this.error = true;
          this.mensjageerror = "El archivo excede el tamaño permitido de 2MB.";
        } 
        else if (this.$refs.file.value === "") {
          this.error = true;
          this.mensjageerror = "Archivo invalido.";
        } else if (!(
          this.$refs.file.files[0].type.includes("application/pdf") ||
          this.$refs.file.files[0].type.includes("image/"))) {
          this.error = true;
          this.mensjageerror = "Formato no admitido por el sistema";
        } 
        else {
          this.error = false;
          this.mensjageerror = "";
        }
        this.file = file;
      }
    },
    async save() {
      if (this.error) {
        return this.error;
      }
      if (this.$refs.form.validate()) {
        this.loading = true;

        
        this.form.anios = parseInt(this.form.anios);
        this.form.anios = Math.abs(this.form.anios);

        this.form.meses = parseInt(this.form.meses);
        this.form.dias = parseInt(this.form.dias);


        try {
          if (this.cargado) {
            let formData = new FormData();
            formData.append("file", this.file);
            let res = await this.$http.post(
              process.env.API_URL + "public/upload",
              formData
            );
            this.form.url_documento = res.data;
          }
          if (this.form.id) {

            const id = this.form.id;
            delete this.form.id;
            delete this.form._user_created;
            delete this.form._user_updated;
            delete this.form._created_at;
            delete this.form._updated_at;

            await this.$service.graphql({
              query: `
								mutation edit($id: ID!, $cas: EditCas!){
									casEdit(id: $id, cas: $cas){
										id
									}
								}
							`,
              variables: {
                id: id,
                cas: this.form,
              },
            });
          } else {
            if (!this.cargado) {
              this.error = true;
              this.mensjageerror = "Debe seleccionar un archivo.";
              this.loading = false;
              return false;
            } else {
              this.error = false;
              this.mensjageerror = "";
            }
            this.form.id_estado = 1;
            const user = this.$storage.get("user");
            if (this.$route.params.id) {
              this.form.id_persona = parseInt(this.$route.params.id)
            } else {
              this.form.id_persona = user.id_persona
            }
            await this.$service.graphql({
              query: `
								mutation add($cas: NewCas!){
									casAdd(cas: $cas){
										id
									}
								}
							`,
              variables: {
                cas: this.form,
              },
            });
          }
        } catch (error) {
          console.log(error);
        }
        document.getElementById("input").value = "";
        this.$message.success();
        this.loading = false;
        this.close();
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/admin/ficha_personal/dialogs/CrearActualizarCas.vue